// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { EngagementRingFiltersFragmentDoc } from '../../../graphql/api/product/rings/engagement/ring/fragments/engagementRingFilters.fragment.generated';
import { FilterPriceRangeFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/filterPriceRange.fragment.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { FilterEngagementRingStyleFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/filterEngagementRingStyle.fragment.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../domain/product/useFacetedContent.generated';
import { FilterEngagementRingDesignFeatureFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/filterEngagementRingDesignFeature.fragment.generated';
import { FilterEngagementRingDesignStyleFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/filterEngagementRingDesignStyle.fragment.generated';
import { FilterShapeFragmentDoc } from '../../../graphql/api/product/rings/engagement/ring/fragments/filterShape.fragment.generated';
import { MetalFilterFragmentDoc, MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { ProductGridFragmentDoc } from '../../../components/rings/product-grid/ProductGrid.generated';
import { ProductCardFragmentDoc } from '../../../components/layout/cards/ProductCard.fragment.generated';
import { ProductLinkFragmentDoc } from '../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
import { GetIsLabGrownFragmentDoc } from '../../../domain/product/getIsLabGrown.generated';
import { MonolithImageSizeFragmentDoc } from '../../../components/monolithImageSize.fragment.generated';
import { ProductListAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { ProductPageFacetedContentFragmentDoc } from '../../../graphql/api/product/faceted-content/productPageFacetedContent.fragment.generated';
import { ProductPageFacetedContentLongDescriptionFragmentDoc } from '../../../graphql/api/product/faceted-content/productPageFacetedContentLongDescription.fragment.generated';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { BlockAnchorFragmentDoc } from '../../../components/cms/BlockAnchor.fragment.generated';
import { ComponentFragmentDoc } from '../../../components/cms/CmsComponent.fragment.generated';
import { ComponentsFragmentDoc } from '../../../components/cms/component.generated';
import { ComponentRoundedImageFragmentDoc } from '../../../components/cms/component/ComponentRoundedImage.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../../components/cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../components/cms/imageSize.fragment.generated';
import { ComponentRoundedImageContentFragmentDoc } from '../../../components/cms/component/ComponentRoundedImageContent.fragment.generated';
import { ContentComponentItemFragmentDoc } from '../../../components/cms/component/ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from '../../../components/cms/component/content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from '../../../components/cms/component/content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from '../../../components/cms/component/content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from '../../../components/cms/component/content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from '../../../components/cms/component/content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from '../../../components/cms/component/content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../components/cms/index.generated';
import { ComponentSpacerFragmentDoc } from '../../../components/cms/component/content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from '../../../components/cms/component/content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from '../../../components/cms/component/content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from '../../../components/cms/component/content/orderedListItem.generated';
import { ComponentContentFragmentDoc } from '../../../components/cms/component/ComponentContent.fragment.generated';
import { ComponentCardFragmentDoc } from '../../../components/cms/component/CardComponent.fragment.generated';
import { ComponentTextOverImageFragmentDoc } from '../../../components/cms/component/ComponentTextOverImage.fragment.generated';
import { ComponentCustomProductCarouselFragmentDoc } from '../../../components/cms/component/ComponentCustomProductCarousel.fragment.generated';
import { CustomProductCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/CustomProductCarouselCard.fragment.generated';
import { ComponentCatalogueProductCarouselFragmentDoc } from '../../../components/cms/component/ComponentCatalogueProductCarousel.fragment.generated';
import { ComponentReviewCarouselFragmentDoc } from '../../../components/cms/component/ComponentReviewCarousel.fragment.generated';
import { ComponentMainCoverFragmentDoc } from '../../../components/cms/component/ComponentMainCover.fragment.generated';
import { VideoFragmentDoc } from '../../../components/cms/video.fragment.generated';
import { ComponentVideoFragmentDoc } from '../../../components/cms/component/ComponentVideo.fragment.generated';
import { ComponentVideoWithContentFragmentDoc } from '../../../components/cms/component/ComponentVideoWithContent.fragment.generated';
import { ComponentInstagramPostsFragmentDoc } from '../../../components/cms/component/ComponentInstagramPosts.fragment.generated';
import { ComponentLogosFragmentDoc } from '../../../components/cms/component/ComponentLogos.fragment.generated';
import { ComponentLogosCarouselFragmentDoc } from '../../../components/cms/component/ComponentLogosCarousel.fragment.generated';
import { ComponentTextWithImageFragmentDoc } from '../../../components/cms/component/ComponentTextWithImage.fragment.generated';
import { ComponentGalleryCarouselFragmentDoc } from '../../../components/cms/component/ComponentGalleryCarousel.fragment.generated';
import { GalleryCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/GalleryCarouselCard.fragment.generated';
import { ComponentCardCarouselFragmentDoc } from '../../../components/cms/component/carousel/card/ComponentCardCarousel.fragment.generated';
import { CardCarouselCardFragmentDoc } from '../../../components/cms/component/carousel/card/CardCarouselCard.fragment.generated';
import { ComponentFullWidthImageFragmentDoc } from '../../../components/cms/component/ComponentFullWidthImage.fragment.generated';
import { ComponentSideBySideImagesFragmentDoc } from '../../../components/cms/component/ComponentSideBySideImages.fragment.generated';
import { ComponentSideBySideImageFragmentDoc } from '../../../components/cms/component/side-by-side-images/ComponentSideBySideImage.fragment.generated';
import { ComponentArticlePreviewsFragmentDoc } from '../../../components/cms/component/ComponentArticlePreviews.fragment.generated';
import { ArticlePreviewFragmentDoc } from '../../../components/cms/component/article-previews/ArticlePreview.fragment.generated';
import { ComponentInstagramWithContentFragmentDoc } from '../../../components/cms/component/ComponentInstagramWithContent.fragment.generated';
import { ComponentBannerTitleFragmentDoc } from '../../../components/cms/component/ComponentBannerTitle.fragment.generated';
import { ComponentQuoteFragmentDoc } from '../../../components/cms/component/ComponentQuote.fragment.generated';
import { ComponentBannerSkinnyFragmentDoc } from '../../../components/cms/component/ComponentBannerSkinny.fragment.generated';
import { ComponentGlobalSpacerFragmentDoc } from '../../../components/cms/component/ComponentGlobalSpacer.fragment.generated';
import { ComponentTextWithImageCarouselFragmentDoc } from '../../../components/cms/component/ComponentTextWithImageCarousel.fragment.generated';
import { ComponentContentWithGalleryFragmentDoc } from '../../../components/cms/component/ComponentContentWithGallery.fragment.generated';
import { ComponentIconCarouselFragmentDoc } from '../../../components/cms/component/ComponentIconCarousel.fragment.generated';
import { ComponentTextCarouselFragmentDoc } from '../../../components/cms/component/ComponentTextCarousel.fragment.generated';
import { ComponentFaqFragmentDoc } from '../../../components/cms/component/ComponentFaq.fragment.generated';
import { FaqSectionFragmentDoc } from '../../../components/cms/component/faq/FaqSection.fragment.generated';
import { FaqQuestionFragmentDoc } from '../../../components/cms/component/faq/FaqQuestion.fragment.generated';
import { ComponentContentTwoColumnsFragmentDoc } from '../../../components/cms/component/ComponentContentTwoColumns.fragment.generated';
import { ComponentTableFragmentDoc } from '../../../components/cms/component/ComponentTable.fragment.generated';
import { ComponentArticleGridFragmentDoc } from '../../../components/cms/component/ComponentArticleGrid.fragment.generated';
import { ArticleGridItemFragmentDoc } from '../../../components/cms/component/article-grid/ArticleGridItem.fragment.generated';
import { ComponentOnThisPageFragmentDoc } from '../../../components/cms/component/ComponentOnThisPage.fragment.generated';
import { ComponentGalleryWithEnquiryFragmentDoc } from '../../../components/cms/component/gallery-with-enquiry/componentGalleryWithEnquiry.fragment.generated';
import { GalleryWithEnquiryCardFragmentDoc } from '../../../components/cms/component/gallery-with-enquiry/galleryWithEnquiryCard.fragment.generated';
import { ComponentSquareBoxesFragmentDoc } from '../../../components/cms/component/square-boxes/ComponentSquareBoxes.fragment.generated';
import { SquareBoxesFragmentDoc } from '../../../components/cms/component/square-boxes/squareBoxes.fragment.generated';
import { SquareTextBoxFragmentDoc } from '../../../components/cms/component/square-boxes/SquareTextBox.fragment.generated';
import { SquareImageBoxFragmentDoc } from '../../../components/cms/component/square-boxes/SquareImageBox.fragment.generated';
import { ComponentShopWithConfidenceFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { ComponentWarrantyActivationFormFragmentDoc } from '../../../components/cms/component/ComponentWarrantyActivationForm.fragment.generated';
import { ComponentJobsFragmentDoc } from '../../../components/cms/component/ComponentJobs.fragment.generated';
import { ComponentJobsJobFragmentDoc } from '../../../components/cms/component/ComponentJobsJob.fragment.generated';
import { ComponentLogosWithTextFragmentDoc, LogoWithTextFragmentDoc } from '../../../components/cms/component/ComponentLogosWithText.fragment.generated';
import { ComponentGlobalComponentFragmentDoc } from '../../../components/cms/component/ComponentGlobalComponent.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../graphql/api/cms/pageProductListing.fragment.generated';
import { Banner1FragmentDoc } from '../../../graphql/api/fragments/banner1.fragment.generated';
import { Banner2FragmentDoc } from '../../../graphql/api/fragments/banner2.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const EngagementRingBrowseDocument = `
    query engagementRingBrowse($currency: CurrencyInput!, $country: CountryCode!, $filter: CatalogueEngagementRingsFilterInput!, $page: Int!, $locale: Locale!, $limit: Int!, $path: String!, $facetedContentInput: ProductPageFacetedContentInput!, $sortBy: CatalogueSortOrder!) {
  catalogueEngagementRingFilters(input: $filter) {
    ...engagementRingFilters
  }
  catalogueEngagementRingsAggregate(filter: $filter) {
    count
  }
  catalogueEngagementRings(
    filter: $filter
    sort: {by: $sortBy, currency: $currency}
    pagination: {page: $page, limit: $limit}
  ) {
    ...productGrid
  }
  pageProductListingFacetedContent(input: $facetedContentInput, locale: $locale) {
    ...productPageFacetedContent
  }
  pageProductListing(path: $path, locale: $locale) {
    ...productPageListing
  }
}
    ${EngagementRingFiltersFragmentDoc}
${FilterPriceRangeFragmentDoc}
${MoneyFragmentDoc}
${FilterEngagementRingStyleFragmentDoc}
${FacetedContentProductLabelTranslationFragmentDoc}
${FilterEngagementRingDesignFeatureFragmentDoc}
${FilterEngagementRingDesignStyleFragmentDoc}
${FilterShapeFragmentDoc}
${MetalFilterFragmentDoc}
${MetalFilterMetalFragmentDoc}
${ProductGridFragmentDoc}
${ProductCardFragmentDoc}
${ProductLinkFragmentDoc}
${EngagementRingLinkFragmentDoc}
${JewelleryLinkFragmentDoc}
${ReadyToGoRingLinkFragmentDoc}
${WeddingRingLinkFragmentDoc}
${MetalVariationFragmentDoc}
${GetIsLabGrownFragmentDoc}
${MonolithImageSizeFragmentDoc}
${ProductListAnalyticsFragmentDoc}
${ProductPageFacetedContentFragmentDoc}
${ProductPageFacetedContentLongDescriptionFragmentDoc}
${BlockFragmentDoc}
${BlockAnchorFragmentDoc}
${ComponentFragmentDoc}
${ComponentsFragmentDoc}
${ComponentRoundedImageFragmentDoc}
${CmsImageSizesFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}
${ComponentRoundedImageContentFragmentDoc}
${ContentComponentItemFragmentDoc}
${ComponentTitleFragmentDoc}
${ComponentTitleComponentFragmentDoc}
${ComponentTitleAmpersandFragmentDoc}
${ComponentTitleTextFragmentDoc}
${ComponentTextFragmentDoc}
${ComponentButtonFragmentDoc}
${LinkFragmentDoc}
${LinkItemFragmentDoc}
${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}
${ComponentSpacerFragmentDoc}
${ComponentImageFragmentDoc}
${ComponentOrderedListFragmentDoc}
${OrderedListItemFragmentDoc}
${ComponentContentFragmentDoc}
${ComponentCardFragmentDoc}
${ComponentTextOverImageFragmentDoc}
${ComponentCustomProductCarouselFragmentDoc}
${CustomProductCarouselCardFragmentDoc}
${ComponentCatalogueProductCarouselFragmentDoc}
${ComponentReviewCarouselFragmentDoc}
${ComponentMainCoverFragmentDoc}
${VideoFragmentDoc}
${ComponentVideoFragmentDoc}
${ComponentVideoWithContentFragmentDoc}
${ComponentInstagramPostsFragmentDoc}
${ComponentLogosFragmentDoc}
${ComponentLogosCarouselFragmentDoc}
${ComponentTextWithImageFragmentDoc}
${ComponentGalleryCarouselFragmentDoc}
${GalleryCarouselCardFragmentDoc}
${ComponentCardCarouselFragmentDoc}
${CardCarouselCardFragmentDoc}
${ComponentFullWidthImageFragmentDoc}
${ComponentSideBySideImagesFragmentDoc}
${ComponentSideBySideImageFragmentDoc}
${ComponentArticlePreviewsFragmentDoc}
${ArticlePreviewFragmentDoc}
${ComponentInstagramWithContentFragmentDoc}
${ComponentBannerTitleFragmentDoc}
${ComponentQuoteFragmentDoc}
${ComponentBannerSkinnyFragmentDoc}
${ComponentGlobalSpacerFragmentDoc}
${ComponentTextWithImageCarouselFragmentDoc}
${ComponentContentWithGalleryFragmentDoc}
${ComponentIconCarouselFragmentDoc}
${ComponentTextCarouselFragmentDoc}
${ComponentFaqFragmentDoc}
${FaqSectionFragmentDoc}
${FaqQuestionFragmentDoc}
${ComponentContentTwoColumnsFragmentDoc}
${ComponentTableFragmentDoc}
${ComponentArticleGridFragmentDoc}
${ArticleGridItemFragmentDoc}
${ComponentOnThisPageFragmentDoc}
${ComponentGalleryWithEnquiryFragmentDoc}
${GalleryWithEnquiryCardFragmentDoc}
${ComponentSquareBoxesFragmentDoc}
${SquareBoxesFragmentDoc}
${SquareTextBoxFragmentDoc}
${SquareImageBoxFragmentDoc}
${ComponentShopWithConfidenceFragmentDoc}
${ComponentWarrantyActivationFormFragmentDoc}
${ComponentJobsFragmentDoc}
${ComponentJobsJobFragmentDoc}
${ComponentLogosWithTextFragmentDoc}
${LogoWithTextFragmentDoc}
${ComponentGlobalComponentFragmentDoc}
${MetaFragmentDoc}
${ProductPageListingFragmentDoc}
${Banner1FragmentDoc}
${Banner2FragmentDoc}`;

export function useEngagementRingBrowseQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.EngagementRingBrowseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.EngagementRingBrowseQuery, SchemaTypes.EngagementRingBrowseQueryVariables | undefined>({ query: EngagementRingBrowseDocument, variables: undefined, ...options });
};